'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import Wrapper from '@components/wrapper/Wrapper';
import { fetchNavList, navListSelector } from '@lib/store/slices/TermsSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TermItem from '../term-item/TermItem';
import style from './FlatTerms.module.scss';
const FlatTerms = () => {
  const $ = _c(23);
  const [toggle, setToggle] = useState(false);
  const svgRef = useRef(null);
  const dispatch = useDispatch();
  const navList = useSelector(navListSelector);
  const {
    isMobile,
    viewport
  } = useViewport();
  let t0;
  if ($[0] !== isMobile) {
    t0 = () => {
      const element = svgRef.current;
      let st6 = null;
      setTimeout(() => {
        st6 = ScrollTrigger.create({
          trigger: element,
          start: "center center",
          scroller: !isMobile ? "#smooth-wrapper" : "body",
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle(_temp);
            }, 100);
          }
        });
        return () => {
          st6.kill();
        };
      }, 300);
    };
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== viewport) {
    t1 = [svgRef, viewport];
    $[2] = viewport;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(_temp3, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(_temp5, t3);
  let t4;
  let t5;
  if ($[6] !== dispatch || $[7] !== navList) {
    t4 = () => {
      if (!navList) {
        dispatch(fetchNavList());
      }
    };
    t5 = [dispatch, navList];
    $[6] = dispatch;
    $[7] = navList;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== isMobile) {
    t6 = !isMobile ? <><p className={style.flatTerms__title}>Условия</p><p className={style.flatTerms__title}>покупки квартиры</p></> : <><p className={style.flatTerms__title}>Условия покупки</p><p className={style.flatTerms__title}>квартиры</p></>;
    $[10] = isMobile;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== navList?.menuItems) {
    t7 = navList?.menuItems?.map(_temp6);
    $[12] = navList?.menuItems;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className={style.flatTerms__terms}>{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isMobile || $[17] !== toggle) {
    t9 = !isMobile && <AnimateLines id="vector_8" className={style.flatTerms__svgClass} toggle={toggle} />;
    $[16] = isMobile;
    $[17] = toggle;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div ref={svgRef} className={style.flatTerms}><Wrapper>{t6}{t8}{t9}</Wrapper></div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default FlatTerms;
function _temp() {
  return true;
}
function _temp2() {
  if (ScrollTrigger.getById("trigger2")) {
    ScrollTrigger.getById("trigger2").kill();
  }
}
function _temp3() {
  return _temp2;
}
function _temp4() {
  if (ScrollTrigger.getById("trigger2")) {
    ScrollTrigger.getById("trigger2").kill();
  }
}
function _temp5() {
  return _temp4;
}
function _temp6(el) {
  return <TermItem {...el} key={el.id} />;
}